import React from "react";
import { StyleSheet, View } from "react-native";
import TeamIcon from "app/components/Icons/TeamIcon";
import theme from "app/Theme/Theme";
import FireIcon from "app/components/Icons/FireIcon";
import LightningIcon from "app/components/Icons/LightningIcon";

const BOX_SIZE = 40;

const icons = {
  streak: {
    color: theme.colors["system.red.100"],
    icon: <FireIcon color={theme.colors["system.red.900"]} />,
  },
  action: {
    color: theme.colors["system.orange.100"],
    icon: <LightningIcon color={theme.colors["system.orange.900"]} />,
  },
  team: {
    color: theme.colors["system.green.100"],
    icon: <TeamIcon color={theme.colors["system.green.900"]} />,
  },
};

const styles = StyleSheet.create({
  main: {
    height: BOX_SIZE,
    width: BOX_SIZE,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
});

const IconBox = ({ iconName = "action" }) => {
  const { color, icon } = icons[iconName];
  return <View style={[styles.main, { backgroundColor: color }]}>{icon}</View>;
};

export default IconBox;
